import Vue from 'vue';
import None from '@/components/layout/None';
import Default from '@/components/layout/Default';

Vue.component('none-layout', None);
Vue.component('default-layout', Default);